@if (appPhase === AppPhase.DealingCards || appPhase === AppPhase.Decision || appPhase === AppPhase.RoundEnd) {
    @if (game) {
        @if (gameType === GameType.DragonTiger || gameType === GameType.OpenDragonTiger) {
            <app-dragon-tiger-table [title]="game.data.title" [sides]="game.data.sides" [cards]="game.data.cards"></app-dragon-tiger-table>
        }

        @if (gameType === GameType.Baccarat || gameType === GameType.OpenBaccarat) {
            <app-baccarat-table [title]="game.data.title" [sides]="game.data.sides" [cards]="game.data.cards"></app-baccarat-table>
        }

        @if (gameType === GameType.ThreeHeadedDragon) {
            <app-three-headed-dragon-table
                [title]="game.data.title"
                [sides]="game.data.sides"
                [cards]="game.data.cards"
            ></app-three-headed-dragon-table>
        }
    }
}

<div class="count-down-container count-down-{{ gameType | lowercase }}">
    <ng-content></ng-content>
</div>
